import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import { useOrgParams } from '~/common/use-org-params'
import { useSeasonList } from './use-season-list'

/**
 * Automatically writes the active season's ID into the URL search params
 * when no seasonId is present. Must be called in a component that is always
 * mounted (e.g. AppBar), not inside a conditionally-rendered menu.
 */
export const useSeasonAutoDefault = () => {
  const { farmId, seasonId } = useOrgParams()
  const [, setSearchParams] = useSearchParams()
  const { seasons, loading } = useSeasonList({ farmId })

  useEffect(() => {
    if (loading || seasons.length === 0 || seasonId) return
    const activeSeason = seasons.find(s => s.state === 'active')
    if (!activeSeason) return
    setSearchParams(prev => {
      const next = new URLSearchParams(prev)
      next.set('seasonId', activeSeason.id)
      return next
    }, { replace: true })
  }, [loading, seasons, seasonId, setSearchParams])
}
